import React, { useMemo } from "react";
import DataGrid from "devextreme-react/data-grid";
import LocationMasterSubTabs from "./LocationMasterSubTabs";
import { LOCATION_COLUMNS } from "../transactionsTab/referenceColumns";

// Location Master top grid (Delphi frmIMM0051.qryIMLocation) + the show-all sub-tabs below. The sub-tabs are
// not linked to the selected row, so no selection is pushed down.
function LocationMasterSearchResults(props) {
  const pager = useMemo(() => ({ visible: true, showPageSizeSelector: true, allowedPageSizes: [20, 50, 100], showInfo: true }), []);

  return (
    <div>
      <div style={{ height: "calc((100vh - 300px) / 2)", marginTop: 8 }}>
        <DataGrid
          dataSource={props.data}
          columns={LOCATION_COLUMNS}
          remoteOperations={true}
          showBorders={true}
          columnAutoWidth={true}
          height="100%"
          sorting={{ mode: "multiple" }}
          filterRow={{ visible: true }}
          headerFilter={{ visible: true }}
          columnChooser={{ enabled: true }}
          export={{ enabled: true }}
          selection={{ mode: "single" }}
          paging={{ pageSize: 20 }}
          pager={pager}
        />
      </div>
      <div style={{ marginTop: 8 }}>
        <LocationMasterSubTabs accessToken={props.accessToken} />
      </div>
    </div>
  );
}

export default LocationMasterSearchResults;
